
export class ProductFilterOptions {
    productIds: Array<number>;
    platformIds: Array<number>;
    leadSMEIds: Array<number>;
    diagramTypeIds: Array<number>;
}
